import { Banca } from '../@types';
import Service from './Service';

class BancaService extends Service {
  static getBancas() {
    return this.Http.get<Banca.Banca[]>('/testingagencies').then(
      this.getData
    );
  }

  static getBanca(id: string) {
    return this.Http.get<Banca.Banca>(`/testingagencies/${id}`).then(
      this.getData
    );
  }

  static inserirNovaBanca(banca: Banca.Banca) {
    return this.Http.post<Banca.Banca>(
      '/testingagencies',
      banca
    ).then(this.getData);
  }

  static atualizarBanca(banca: Banca.Banca) {
    return this.Http.put<Banca.Banca>(
      `/testingagencies/${banca.id}`,
      banca
    ).then(this.getData);
  }

  static deletarBanca(id: string) {
    return this.Http.delete(`/testingagencies/${id}`).then(this.getData);
  }
}

export default BancaService;
